import React, { Component } from "react";
import MainLayout from "../../Components/Layouts/MainLayout";
import CardBlock from "../../Components/CardBlock";
import Spinner from "../../Utils/Spinner";
import CertificatesList from "../../Components/CertificatesList";
import LabTestList from "../../Components/LabTestList";

export default class AllInspectionReportsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: null,
      errorMessage: null,
      user: {},
    };
  }

  componentDidMount() {}

  render() {
    return (
      <MainLayout title="Inspection Reports">
        <div className="row">
          <div className="col-md-12 mb-5">
            {this.state.loading ? (
              <Spinner />
            ) : (
              <CardBlock>
                <LabTestList
                  laboratoryId={this.props.match.params.laboratoryId || 0}
                  retailOutletId={this.props.match.params.retailOutletId || 0}
                  vetId={this.props.match.params.vetId || 0}
                />
              </CardBlock>
            )}
          </div>
        </div>
      </MainLayout>
    );
  }
}
